import * as Sentry from '@sentry/nextjs'
import { globalUserProxy } from '../../../../proxies/globalUserProxy'

export async function isLatestVersion (): Promise<void> {
  const localVersion = process.env.npm_package_version

  try {
    const response = await fetch('/api/release_version')
    const data = await response.json()

    globalUserProxy.isVersionBannerDisplayed = (localVersion !== data.version)
  } catch (e) {
    if (e instanceof Error) {
      Sentry.captureException(e)
    }
  }
}
